import Api from './api'

export default {
   getOtherBeneficiaries() {
      return Api().get('/umbraco/surface/api/getotherbeneficiaries');
   }
}


// WEBPACK FOOTER //
// ./src/api/contentApi.js